import type React from "react";
import { useState, useEffect } from "react";

const DEFAULT_TIMEOUT = 500;
export function useDebounce<T>(initialValue: T, timeout: number = DEFAULT_TIMEOUT): [T, React.Dispatch<T>, T] {
    const [value, setValue] = useState<T>(initialValue);
    const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

    useEffect(() => {
        const debounce = setTimeout(() => {
            setDebouncedValue(value);
        }, timeout);
        return () => {
            clearTimeout(debounce);
        };
    }, [value, timeout]);

    return [debouncedValue, setValue, value];
}
